import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IProspectAddReduxProps, IProspect, IProspectAdd, ITarget } from '../../types/interfaces';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import { addProspect } from '../../flux/actions/prospectActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faCheckSquare, faExternalLinkAlt, faFileImage, faHandRock, faPen, faPlus, faRedo, faSpinner, faSquare, faTimes, faUndo } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";

import NumberFormat from 'react-number-format';
import DatePicker from "reactstrap-date-picker";
import PhoneInput from "react-phone-input-2";
import frPhoneInput from 'react-phone-input-2/lang/fr.json'
import 'react-phone-input-2/lib/bootstrap.css'

import { constants } from '../../types/constants';

const ProspectAdd = ({
  modal,
  setModal,
  addTableProspectCallback,
  addProspect,
  getSocietes,
  getUsers,
  societe,
  user,
  autoSelectUserId,
  auth
 }: IProspectAdd) => {
  const alert = useAlert();
  const { societes, loading: loadingS } = societe;
  const { users, loading: loadingU } = user;
  const selectOptions = societes.map(e => ({value: e, label: e.LIBELE}));
  const [societeValue, setSocieteValue] = useState<any>('');
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const civiliteOptions = [{value: "Mme", label: "Madame"}, {value: "Mr", label: "Monsieur"}, {value: "Ste", label: "Société"}];
  const [selectedCivilite, setSelectedCivilite] = useState<any>('');
  const [nameValue, setName] = useState('');
  const [professionValue, setProfession] = useState('');
  const typeProfessionOptions = ["Salarié", "Fonctionnaire d'état", "Commerçant", "Société / Personne morale", "Sans"].map(e => ({value: e, label: e}));
  const [typeProfession, setTypeProfession] = useState<any>('');
  const [telValue, setTel] = useState<any>('');
  const [tel2Value, setTel2] = useState<any>('');
  const [telIsValid, setTelIsValid] = useState(true);
  const [tel2IsValid, setTel2IsValid] = useState(true);
  const [villeValue, setVille] = useState('');
  const paysOptions = ["Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre", "Angola", "Antigua-et-Barbuda", "Arabie saoudite", "Argentine", "Arménie", "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Bélarus", "Belgique", "Belize", "Bénin", "Bhoutan", "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil", "Brunéi Darussalam", "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada", "Cap-Vert", "Chili", "Chine", "Chypre", "Colombie", "Comores", "Congo", "Congo, (République démocratique du) ", "Corée, (République de) ", "Corée, (République populaire démocratique de)", "Costa Rica", "Côte d'Ivoire", "Croatie", "Cuba", "Danemark", "Djibouti", "Dominique", "Egypte", "El Salvador", "Emirats arabes unis", "Equateur", "Erythrée", "Espagne", "Estonie", "Etats-Unis", "Ethiopie", "Fidji", "Finlande", "France", "Gabon", "Gambie", "Géorgie", "Ghana", "Grèce", "Grenade", "Guatemala", "Guinée", "Guinée-Bissau", "Guinée équatoriale", "Guyana", "Haïti", "Honduras", "Hongrie", "Iles Cook", "Iles Marshall", "Iles Salomon", "Inde", "Indonésie", "Iran (République islamique d')", "Iraq", "Irlande", "Islande", "Israël", "Italie", "Jamahiriya arabe libyenne", "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya", "Kirghizistan", "Kiribati", "Koweït", "l'ex-République yougoslave de Macédoine", "Lesotho", "Lettonie", "Liban", "Libéria", "Liechtenstein", "Lituanie", "Luxembourg", "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali", "Malte", "Maroc", "Maurice", "Mauritanie", "Mexique", "Micronésie, (Etats fédérés de)", "Moldova, (République de)", "Monaco", "Mongolie", "Mozambique", "Myanmar", "Namibie", "Nauru", "Népal", "Nicaragua", "Niger", "Nigéria", "Nioué", "Norvège", "Nouvelle-Zélande", "Oman", "Ouganda", "Ouzbékistan", "Pakistan", "Palaos", "Panama", "Papouasie-Nouvelle Guinée", "Paraguay", "Pays-Bas", "Pérou", "Philippines", "Pologne", "Portugal", "Qatar", "Rép. démocratique populaire lao ", "République centrafricaine", "République dominicaine", "République tchèque", "Roumanie", "Royaume-Uni", "Russie, (Fédération de)", "Rwanda", "Sainte-Lucie", "Saint-Kitts-et-Nevis", "Saint-Marin", "Saint-Siège", "Saint-Vincent-et-Grenadines", "Samoa", "Sao Tomé-et-Principe", "Sénégal", "Serbie-et-Monténégro", "Seychelles", "Sierra Leone", "Singapour ", "Slovaquie", "Slovénie", "Somalie ", "Soudan", "Sri Lanka", "Suède", "Suisse", "Suriname", "Swaziland", "Syrie, (République arabe de)", "Tadjikistan ", "Tanzanie, (République-Unie de)", "Tchad", "Territoire palestinien occupé", "Thaïlande", "Timor-Leste", "Togo", "Tonga", "Trinité-et-Tobago", "Tunisie", "Turkménistan", "Turquie", "Tuvalu", "Ukraine ", "Uruguay", "Vanuatu", "Venezuela", "Viet Nam", "Yémen", "Zambie", "Zimbabwe"].map(e => ({value: e, label: e}));
  const [selectedPays, setSelectedPays] = useState(paysOptions[111]);
  const villeOptions = ["AGADIR", "AGADIR DEPOT", "AGLMOUS", "AHFIR", "AIN AOUDA", "AIN ATIQ", "AIN BENI MATHAR", "AIN HARROUDA", "AIN LEUH", "AIN TAOUJDATE", "AIT BAHA", "AIT MELLOUL", "AIT OURIR", "AL ARUIT", "AL HAOUZ", "AL HOCEIMA", "AMSCROUD", "AOUSSERD", "ASILAH", "AZEMMOUR", "AZILAL", "AZROU", "BEJAAD", "BEN AHMED", "BEN GUERIR", "BEN SLIMANE", "BENI ANSAR", "BENI MELLAL", "BERKANE", "BERRECHID", "BIOUGRA", "BIR JDID", "BOUARFA", "BOUDINAR", "BOUFEKRANE", "BOUIZAKARNE", "BOUIZAKARNE", "BOUJAAD", "BOUJDOUR", "BOUKNADEL", "BOULMANE", "BOUMALNE DADES", "BOUSKOURA", "BOUZNIKA", "CABO NEGRO", "CASABLANCA", "CHAOUEN", "CHEFCHAOUEN", "CHEMAIA", "CHICHAOUA", "DAKHLA", "DAR BOUAZZA", "DAR EL GUEDDARI", "DCHEIRA", "DEMNATE", "EL AIOUN", "EL ATTAOUIA", "EL BROUJE", "EL GARA", "EL HAJEB", "EL JADIDA", "EL KALEAA", "EL KSIBA", "EL MHARIS", "EL OUALIDIA", "EL WAHDA / M'JAARA", "ERFOUD", "ERRACHIDIA", "ESSAOUIRA", "FES", "FIGUIG", "FNIDEQ", "FQUIH BEN SALAH", "GOULMIMA", "GOULMIME", "GUEMMASSA", "GUERCIF", "HAD GHOUALEM", "HAD KOURT", "HAD SOUALEM", "HOUARA", "IFNI", "IFRANE", "IMINTANOUT", "IMINTANOUTE", "IMITER", "IMOUZER", "IMZOUREN", "INCONNUE", "INEZGANE", "INZEGANE", "JORF EL MELHA", "JORF LASFAR", "JRADA", "K DES SRAGHNA", "KALAA MGOUNA", "KALAA SRAGHNA", "KARIAT ARAKMANE", "KARIAT BA MED", "KASBA TADLA", "KELAA MGOUNA", "KENITRA", "KHEMISSET", "KHENICHAT", "KHENIFRA", "KHMIS ZEMAMRA", "KHMISS OLAD AYAD", "KHOURIBGA", "KSAR EL KEBIR", "KSAR SEGHIR", "LAAYOUNE", "LARACHE", "M.B KSIRI", "M'RIRT", "MAROC", "MARRAKECH", "MARTIL", "MASSA", "MDIQ", "MEDIOUNA", "MEHDIA", "MEKNES", "MELOUSSA", "MIDELT", "MINE AKKA", "MISSOUR", "MLY BOUSELHAME", "MOHAMMEDIA", "MONTE AROUI", "MY DRISS ZERHOU", "NADOR", "NOUASSER", "OUARZAZATE", "OUAZZANE", "OUED AMLIL", "OUED EDDAHAB", "OUED ZEM", "OUJDA", "OUKAIMDEN", "OULAD AABOU", "OULED ABBOU", "OULED FREJ", "OULED TEIMA", "OULMES", "OUTAT EL HAJ", "PORT KABILA", "PORT MOHAMMEDIA", "PORT NADOR", "PORT TANGER", "RABAT", "RABAT MAGASIN", "RICH", "ROMANI", "ROMMANI", "S. YAHYA GHARB", "S. YAHYA ZEERS", "S.A GHARB", "S.K.S.O.N.", "S/BENNOUR", "SAFI", "SAIDIA", "SALA AL JADIDA", "SALE", "SALE JADIDA", "SEBT EL GUERDANE", "SEFROU", "SEKSAOUA", "SELOUANE", "SETTAT", "SIDI ALLAL AL BAHRAOUI", "SIDI BETTACHE", "SIDI HAJJAJ", "SIDI HRAZEM", "SIDI IFNI", "SIDI KACEM", "SIDI MAAROUF", "SIDI SLIMANE", "SIDI SMAAL", "SKHIRATE", "SKHIRATE-TEMARA", "SMARA", "SOUK EL ARBA DU GHARB", "SOUK SEBT", "SOUK TLET GHARB", "TAFORALT", "TAFRAOUTE", "TAHADDART", "TAHANAOUT", "TAHLA", "TALSINT/ANOUAL", "TAN TAN", "TANGER", "TAOUNAT", "TAOURIRT", "TARFAYA", "TARFAYA", "TARGUIST", "TAROUDANT", "TATA", "TAZA", "TAZNAKHT", "TEMARA", "TETOUAN", "TIFLET", "TIGHZA", "TIKIOUINE", "TINEJDAD", "TINGHIR", "TINRHIRE", "TISSA", "TIT MELLIL", "TIZNIT", "TLAT LOULAD", "YOUSSOUFIA", "ZAG", "ZAGORA", "ZAYOU", "ZENATA", "ZIAO", "AUTRE"].map(e => ({value: e, label: e}));
  const [selectedVille, setSelectedVille] = useState<any>('');
  const pubOptions = ["Panneau", "Stand", "Mubaweb", "Avito", "Sarouti.ma", "Facebook", "Instagram", "SMS", "Brochure / Flyer", "Bouche à oreille"].map(e => ({value: e, label: e}));
  const [selectedPub, setSelectedPub] = useState<any>('');
  const [dateVisiteValue, setDateVisite] = useState(new Date().toISOString());
  const [observationValue, setObservation] = useState('');
  const defaultInterestEntry = {
    bienType: '',
    surface: {min: 0, max: 0},
    price: {min: 0, max: 0}
  };
  const defaultInterestEntries = {
    1: defaultInterestEntry,
  };
  const [interestEntries, setInterestEntries] = useState<any>(defaultInterestEntries);
  const bienTypesOptions = [{value: 'R+1', label: "R+1"}, {value: 'R+2', label: "R+2"}, {value: 'R+3', label: "R+3"}, {value: 'R+4', label: "R+4"}, {value: 'R+5', label: "R+5"}, {value: 'APP', label: "Appartement"}, {value: 'MAG', label: "Magasin"}];
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  // useEffect(() => {
  //   getUsers();
  // }, [getUsers]);

  useEffect(() => {
    autoSetUser();
  }, [users, autoSelectUserId, auth?.user]);

  const modalClosedHandle = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const handleCiviliteChange = data => {
    setSelectedCivilite(data || '');
  }
  const nameChangeHandler = (e: ITarget) => setName(e.target.value);
  const professionChangeHandler = (e: ITarget) => setProfession(e.target.value);
  const handleTypeProfessionChange = data => {
    setTypeProfession(data || '');
  }
  const telChangeHandler = (value, t) => setTel({value, t});
  const tel2ChangeHandler = (value, t) => setTel2({value, t});
  const villeChangeHandler = (e: ITarget) => setVille(e.target.value);
  const handlePaysChange = data => {
    setSelectedPays(data || '');
  }
  const handleVilleChange = data => {
    setSelectedVille(data || '');
  }
  const handlePubChange = data => {
    setSelectedPub(data || '');
  }
  const dateVisiteChangeHandler = (e, t) => {
    setDateVisite(e);
  };
  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  };
  const observationChangeHandler = (e: ITarget) => setObservation(e.target.value);

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const autoSetUser = () => {
    if(users?.length){
      const userTemp = autoSelectUserId !== undefined ? users.find(e => e.id === autoSelectUserId) : auth?.user ? users.find(e => e.id === auth?.user?.id) : null;
      if(userTemp)
        setUserValue(userTemp)
    }
  }

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Prospect ajouté avec succès");
      if(addTableProspectCallback)
        addTableProspectCallback(success);
      setSelectedCivilite('');
      setName('');
      setProfession('');
      setTypeProfession('');
      setTel('');
      setTel2('');
      setVille('');
      setSelectedPays(paysOptions[111]);
      setSelectedVille('');
      setSelectedPub('');
      setDateVisite(new Date().toISOString());
      setObservation('');
      setInterestEntries(defaultInterestEntries);
      autoSetUser();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const addHandle = async () => {
    if(!societeValue){
      alert.error("Veuillez sélectionner un projet");
      return
    }
    if(selectedCivilite === ''){
      alert.error("Veuillez sélectionner la civilité");
      return
    }
    if(nameValue === ''){
      alert.error("Veuillez saisir un nom");
      return
    }
    if(!typeProfession){
      alert.error("Veuillez sélectionner le type de la profession");
      return
    }
    if(telValue === '' || !telValue.value || telValue.value.length <= 4){
      alert.error("Veuillez saisir le N° de téléphone");
      return
    }
    if(!telIsValid || !tel2IsValid){
      alert.error("N° de téléphone erroné");
      return
    }
    if(!selectedPays){
      alert.error("Veuillez sélectionner le pays");
      return
    }
    if((selectedPays.value === paysOptions[111].value && selectedVille === '') || (selectedPays.value !== paysOptions[111].value && villeValue === '')){
      alert.error("Veuillez sélectionner la ville");
      return
    }
    if(!selectedPub){
      alert.error("Veuillez sélectionner le support publicitaire");
      return
    }
    const interestEntriesArr = /*Object.entries(interestEntries).length === 1 && interestEntries[1] && (!interestEntries[1].bienType && !interestEntries[1].surface?.min && !interestEntries[1].surface?.max && !interestEntries[1].price?.min && !interestEntries[1].price?.max) ? [] : */Object.entries(interestEntries).map(e => e[1])
    if(interestEntriesArr.some((e: any) => !e.bienType)){
      alert.error("Veuillez sélectionner un type");
      return
    }
    if(interestEntriesArr.some((e: any) => !e.surface?.min && !e.surface?.max)){
      alert.error("Veuillez saisir une superficie");
      return
    }
    if(interestEntriesArr.some((e: any) => !e.price?.min && !e.price?.max)){
      alert.error("Veuillez saisir un prix");
      return
    }
    if(!userValue || userValue === ''){
      alert.error("Veuillez sélectionner le commercial");
      return
    }
    setDisableSubmit(true);

    const prospect : IProspect = {
      projectId: societeValue?.id,
      CIVILITE: selectedCivilite.value,
      name: nameValue,
      TEL: telValue?.value ? (telValue.t.dialCode === "212" ? (telValue.value.length > 4 ? ("0" + telValue.value.substr(3)) : "") : telValue.value) : "",
      TEL2: tel2Value?.value ? (tel2Value.t.dialCode === "212" ? (tel2Value.value.length > 4 ? ("0" + tel2Value.value.substr(3)) : "") : tel2Value.value) : "",
      PAYS: selectedPays.value,
      VILLE: selectedPays.value === paysOptions[111].value ? selectedVille.value : villeValue,
      PROFESSION: professionValue,
      TYPE_PROFESSION: typeProfession?.value || null,
      SUPPORT_PUB: selectedPub?.value || null,
      DATE_VISITE: new Date(dateVisiteValue),
      comment: observationValue,
      comId: userValue.id,
      userId: auth?.user?.id,
    };
    addProspect(prospect, interestEntriesArr, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajout d'un nouveau Prospect</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="societe" className="requiredLabel">Projet</Label>
                    <Select
                      name="reactselect"
                      className="reactselect"
                      classNamePrefix="react-select"
                      id="societe"
                      value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                      onChange={handleSocieteChange}
                      placeholder={'Chercher par projet...'}
                      isClearable={true}
                      isLoading={loadingS}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='LIBELE'
                      // valueKey='code'
                      options={selectOptions}
                      filterOption={filterOptions}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="civilite" className="requiredLabel">Civilité</Label>
                    <Select
                      id="civilite"
                      name="civilite"
                      className="reactselect"
                      classNamePrefix="react-select"
                      // defaultValue={civiliteOptions[0]}
                      value={selectedCivilite}
                      // value={{value: societeValue.value, label: societeValue.label}}
                      onChange={handleCiviliteChange}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={civiliteOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="name" className="requiredLabel">Nom complet</Label>
                    <Input id="name" placeholder="Nom complet..." value={nameValue} onChange={nameChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="profession">Profession</Label>
                    <Input id="profession" placeholder="Profession..." value={professionValue} onChange={professionChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="typeProfession" className="requiredLabel">Type Profession</Label>
                    <Select
                      id="typeProfession"
                      name="typeProfession"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={typeProfessionOptions[0]}
                      value={typeProfession}
                      onChange={handleTypeProfessionChange}
                      placeholder={'Type Profession...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={typeProfessionOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel" className="requiredLabel">N° de Téléphone 1</Label>
                    <PhoneInput
                      value={telValue?.value || ""}
                      onChange={telChangeHandler}
                      inputProps={{
                        id: "tel",
                        required: true,
                        autoFocus: false
                      }}
                      inputStyle={{width: "100%"}}
                      localization={frPhoneInput}
                      masks={{ ma: '... .. .. ..' }}
                      country="ma"
                      preferredCountries={["ma"]}
                      // disableCountryCode={true}
                      countryCodeEditable={false}
                      enableSearch={true}
                      searchPlaceholder="Rechercher..."
                      isValid={(value, country) => {
                        const isValid = country["iso2"] !== "ma" || value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0;
                        setTelIsValid(isValid);
                        return isValid
                        if (value.match(/12345/)) {
                          return 'Invalid value: '+value+', '+country["name"];
                        } else if (value.match(/1234/)) {
                          return false;
                        } else {
                          return true;
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel2">N° de Téléphone 2</Label>
                    <PhoneInput
                      value={tel2Value?.value || ""}
                      onChange={tel2ChangeHandler}
                      inputProps={{
                        id: "tel2",
                        required: false,
                        autoFocus: false
                      }}
                      inputStyle={{width: "100%"}}
                      localization={frPhoneInput}
                      masks={{ ma: '... .. .. ..' }}
                      country="ma"
                      preferredCountries={["ma"]}
                      countryCodeEditable={false}
                      enableSearch={true}
                      searchPlaceholder="Rechercher..."
                      isValid={(value, country) => {
                        const isValid = country["iso2"] !== "ma" || value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0;
                        setTel2IsValid(isValid);
                        return isValid
                        // return value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="pays" className="requiredLabel">Pays</Label>
                    <Select
                      id="pays"
                      name="pays"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={paysOptions[111]}
                      value={selectedPays}
                      onChange={handlePaysChange}
                      placeholder={'Pays...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={paysOptions}                
                    />
                    {/* <Input id="pays" placeholder="Pays..." value={paysValue} onChange={paysChangeHandler} /> */}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="ville" className="requiredLabel">Ville</Label>
                    {selectedPays.value === paysOptions[111].value ? <Select
                      id="ville"
                      name="ville"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={villeOptions[0]}
                      value={selectedVille}
                      onChange={handleVilleChange}
                      placeholder={'Ville...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={villeOptions}                
                    /> :
                    <Input id="ville" placeholder="Ville..." value={villeValue} onChange={villeChangeHandler} />}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="pub" className="requiredLabel">Support publicitaire</Label>
                    <Select
                      id="pub"
                      name="pub"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={pubOptions[0]}
                      value={selectedPub}
                      onChange={handlePubChange}
                      placeholder={'Support publicitaire...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={pubOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="datevisite">Date Visite</Label>
                    <DatePicker id="dateVisite"
                      value={dateVisiteValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateVisiteChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="user" className="requiredLabel">Commercial</Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={userValue ? {label: userValue["username"], value: userValue} : null}
                      onChange={handleUserChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='name'
                      // valueKey='countryCode'
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="observation">Commentaire</Label>
                    <Input id="observation" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Label className="requiredLabel">Interessé{selectedCivilite?.value === "Mme" ? "e" : ""} par</Label>
              {Object.entries(interestEntries).map((e: any[], key, arr) => <Container className="CardInfo mb-2" key={key}>
                <Row style={{padding: 0}}>
                  <Col xs="12" style={{border: "none"}}>
                  <FormGroup>
                    <Label style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                      Type
                      <FontAwesomeIcon icon={faTimes} style={{color: "red", cursor: arr.length > 1 ? "pointer" : "default", opacity: arr.length > 1 ? 1 : .2}} onClick={() => (arr.length > 1) && setInterestEntries(e => {
                        const temp = {...e};
                        delete temp[Number(key) + 1];
                        const arrTemp = Object.entries(temp);
                        const res = {};
                        for(let i = 0; i < arrTemp.length; i++)
                          res[i + 1] = arrTemp[i][1]
                        return res
                      })} />
                    </Label>
                    <Select
                      name="reactselect"
                      className="reactselect reactselect-center"
                      classNamePrefix="react-select"
                      value={e[1].bienType ? {label: /*e[1].bienType === 'p' ? "%" : "Forfait" */bienTypesOptions.find(t => t.value === e[1].bienType)?.label, value: e[1].bienType} : null}
                      onChange={t => {
                        setInterestEntries(n => ({...n, [e[0]]: {...n[e[0]], bienType: t?.value || ''}}))
                      }}
                      placeholder={'Type...'}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isClearable
                      options={bienTypesOptions.filter(t => !arr.find((n: any) => n[1].bienType === t.value))}
                    />
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{padding: 0}}>
                  <Col xs="12" sm="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label for={`surface_min_${key}`}>Superficie de</Label>
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id={`surface_min_${key}`} value={e[1].surface?.min} suffix={" m²"} defaultValue={0} onFocus={focusHandler} onValueChange={t => setInterestEntries(n => ({...n, [e[0]]: {...n[e[0]], surface: {...n[e[0]].surface, min: t?.value ? +t.value : 0}}}))} />
                  </FormGroup>
                  </Col>
                  <Col xs="12" sm="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label for={`surface_max_${key}`}>à</Label>
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id={`surface_max_${key}`} value={e[1].surface?.max} suffix={" m²"} defaultValue={0} onFocus={focusHandler} onValueChange={t => setInterestEntries(n => ({...n, [e[0]]: {...n[e[0]], surface: {...n[e[0]].surface, max: t?.value ? +t.value : 0}}}))} />
                  </FormGroup>
                  </Col>
                </Row>
                <Row style={{padding: 0}}>
                  <Col xs="12" sm="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label for={`price_min_${key}`}>Fourchette prix de</Label>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id={`price_min_${key}`} value={e[1].price?.min} defaultValue={0} onFocus={focusHandler} onValueChange={t => setInterestEntries(n => ({...n, [e[0]]: {...n[e[0]], price: {...n[e[0]].price, min: t?.value ? +t.value : 0}}}))} />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label for={`price_max_${key}`}>à</Label>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id={`price_max_${key}`} value={e[1].price?.max} defaultValue={0} onFocus={focusHandler} onValueChange={t => setInterestEntries(n => ({...n, [e[0]]: {...n[e[0]], price: {...n[e[0]].price, max: t?.value ? +t.value : 0}}}))} />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </Container>)}
              <div className="fullFlexCenter">
                <div style={{cursor: "pointer", textDecoration: "underline", fontSize: "small", fontStyle: "italic"}} onClick={() => setInterestEntries(e => ({...e, [Object.entries(e).length + 1]: defaultInterestEntry}))}><FontAwesomeIcon icon={faPen} />&nbsp;Ajouter un autre bien</div>
              </div>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={addHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Ajouter</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IProspectAddReduxProps) => ({
  societe: state.societe,
  user: state.user,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { addProspect, getSocietes, getUsers })(ProspectAdd);
